import { Brand } from '../components/PortalShell';
import { useAuth } from '../auth/AuthContext';

const AccessDenied = () => {
  const { signOut } = useAuth();
  return <main className="centered-page"><div className="denied-card"><Brand /><p className="eyebrow">Access restricted</p><h1>You’re signed in, but this portal isn’t assigned to you.</h1><p>Administration requires DigitalWerks access level 10 or higher. No user-management information has been loaded.</p><button className="button button--primary" type="button" onClick={signOut}>Sign out</button></div></main>;
};
export default AccessDenied;

